import Sidebar3 from "./Sidebar3";
import Sidebar1 from "./Sidebar1";
import Animation9 from "./Animation9";
import Animation14 from "./Animation14";
import Animation10 from "./Animation10";
import Card70 from "./Card70";
import Card71 from "./Card71";
import Card67 from "./Card67";
import Card66 from "./Card66";
import Card69 from "./Card69";
import Card72 from "./Card72";
import Card68 from "./Card68";
import Card13 from "./Card13";
import Card62 from "./Card62";
import Card49 from "./Card49";
import Card11 from "./Card11";
import Footer5 from "./Footer5";
import Table4 from "./Table4";

export default function PageTemplate(){
    return(
        <div className="mt-20">
            <Sidebar1/>
            <Sidebar3/>
            <Animation9/>
            <Animation14/>
            <Animation10/>
            <Card70/>
            <Card69/>
            <Card67/>
            <Card72/>
            <Card66/>
            <Card71/>
            <Card68/>
            <Card13/>
            <Card62/>
            <Card49/>
            <Card11/>
            <Table4/>
            <Footer5/>

        </div>
    )
}